import { Table } from 'react-bootstrap';
import {StyledCell } from '../StyledCells';
import { taskProgressFormatter } from '../../library/formatters';

export const JobProgress  = ({jobData}) =>
{ 
    const taskSummary = jobData.taskSummary;
    return(
            <Table id="job-progress-table" striped size="sm">
            <thead>
                <tr id="job-progress-total">
                    <th id="job-progress-total-label">Total</th> 
                    <th id="job-progress-total-value">{taskSummary.total ? taskSummary.total : 0}</th>
                </tr>
            </thead>
                <tbody>
                    <tr id="job-progress-started">
                        <td id="job-progress-started-label"><div className="d-flex align-items-center">Started</div></td>
                        <td id="job-progress-started-value">{taskSummary.started} ({taskSummary.total !== 0? taskProgressFormatter(taskSummary.started/taskSummary.total): "0%"})</td>
                    </tr>
                    <tr id="job-progress-failed">
                        <td id="job-progress-failed-label"><div className="d-flex align-items-center">Failed</div></td>
                        <td id="job-progress-failed-value">{taskSummary.failed} ({taskSummary.total !== 0? taskProgressFormatter(taskSummary.failed/taskSummary.total) : "0%"})</td>
                    </tr>
                    <tr id="job-progress-completed">
                        <td id="job-progress-completed-label"><div className="d-flex align-items-center">Completed</div></td>
                        <td id="job-progress-completed-value">{taskSummary.completed} ({taskSummary.total !== 0? taskProgressFormatter(taskSummary.completed/taskSummary.total):"0%"})</td> 
                    </tr>
                    <tr id="job-progress-progress">
                        <StyledCell cellContent={"Progress"}/> 
                        <StyledCell cellContent={`${taskSummary.total !== 0? taskProgressFormatter(taskSummary.progress): "0%"}`}/> 
                    </tr>
                </tbody>
            </Table>
    )
}